<template>
  <div class="">
    <div class="camp_item_box" @click.stop="onItem(1)">
      <div class="flexbox camp_item_content_box">
        <div class="c_left">
          <div class="name">{{ item.campPeriodName }}</div>
          <div class="desc">{{ item.goodsDescription }}</div>
          <div class="date">报名日期：{{ item.callUpStartDateStr }} 开启</div>
          <div class="date">
            学习日期：{{ item.battleStartDateStr }}-{{ item.battleEndDateStr }}
          </div>
        </div>
        <img
          class="c_right"
          src="../../../images/trainCamp/right_icon.png"
          alt=""
        />
      </div>

      <div class="bottom_box">
        <div class="flexbox num_box" :class="{ none_box: !canCallUp }">
          剩余<span>{{ item.remainSize }}</span
          >个名额
        </div>
        <!-- 已报名 -->
        <img
          src="../../../images/trainCamp/yibaoming.png"
          v-if="item.joinStatus === 0"
          class="btn"
          alt=""
          @click.stop="onItem(2)"
        />
        <!-- 爆满 -->
        <img
          src="../../../images/trainCamp/baoman.png"
          v-else-if="
            (item.joinStatus === -4 || item.callUpStatus === 3) &&
              item.joinStatus !== 0
          "
          class="btn"
          alt=""
          @click.stop="onItem(2)"
        />
        <!-- 未开始 -->
        <img
          src="../../../images/trainCamp/weikaishi.png"
          v-else-if="item.joinStatus === -2 || item.callUpStatus === 1"
          class="btn"
          alt=""
          @click.stop="onItem(2)"
        />
        <!-- 可报名 -->
        <img
          src="../../../images/trainCamp/baoming.png"
          v-else-if="canCallUp"
          class="btn"
          alt=""
          @click.stop="onItem(2)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {}
  },
  data() {
    return {}
  },
  computed: {
    // 可报名
    canCallUp() {
      const { item } = this
      /**
       * -1 : 身份不匹配
       * -2 : 报名未开始
       * -3 : 报名已结束
       * -4 : 已爆满
       * -5 : 次数用完
       * -6 : 学习时间冲突，您已报名其他训练营～
       *  0 : 已报名
       *  1 : 可报名
       */
      /** 1-待招生 2-招生中 3-待开课 4-行课中 5-已结束*/
      // private Integer callUpStatus;
      // switch
      // if (item.joinStatus === -1) {
      //   return false
      // }
      // if (item.joinStatus === -3) {
      //   return false
      // }
      // if (item.joinStatus === 1) {
      //   return true
      // }
      if (item.joinStatus === -1) {
        return true
      }
      if (item.joinStatus === -5) {
        return true
      }
      if (item.joinStatus === -6) {
        return true
      }
      if (item.joinStatus === 1) {
        return true
      }
      if (item.callUpStatus === 2) {
        return true
      }
      return false
    }
  },
  created() {},
  methods: {
    onItem(type) {
      this.$emit('onItem', { item: this.item, type })
    }
  }
}
</script>

<style lang="less" scoped>
.camp_item_box {
  position: relative;
  padding: 0.24rem 0.32rem;
  background: #fff;
  border-radius: 0.12rem;
  margin-bottom: 0.32rem;
  .camp_item_content_box {
    width: 100%;
    justify-content: space-between;
    .c_left {
      width: 100%;
      padding-right: 0.6rem;
      .name {
        font-size: 0.32rem;
        color: #333333;
        font-weight: 600;
        margin-bottom: 0.24rem;
      }

      .my_text_1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .desc {
        font-size: 0.28rem;
        font-weight: 400;
        color: #333333;
        margin-bottom: 0.24rem;
      }
      .date {
        font-size: 0.24rem;
        color: #666666;
        margin-bottom: 0.16rem;
      }
    }
    .c_right {
      position: absolute;
      top: 50%;
      right: 0.32rem;
      transform: translateY(-50%);
      display: block;
      flex-shrink: 0;
      width: 0.56rem;
      height: 0.56rem;
    }
  }

  .bottom_box {
    margin-top: 0.12rem;
    justify-content: space-between;
    font-size: 0.36rem;
    font-weight: 600;
    color: #333333;
    .num_box {
      margin-bottom: 0.24rem;
    }
    span {
      display: block;
      margin: 0 0.08rem;
      color: #e0a42f;
    }
    .btn {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .none_box {
    opacity: 0.6;
    span {
      color: #000;
    }
  }
}
</style>
